import React, {FC} from "react";
import {Box, Typography} from "@mui/material";
import {CloudUpload} from "@mui/icons-material";
import {AccessibilityImages} from "../../../../../../../../../../../../models/AccessibilityImages";
import {useTranslation} from "react-i18next";
import styled from "@emotion/styled";

const UploadButton = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%);;
  color: black;
  border-radius: 6px;
  border: 1px solid #00F5C3;
  font-weight: 500;
  cursor: pointer;
  padding: 5px 0;
  max-width: 400px;
  width: 100%;
  //margin: 0 13px;
`

const NoHaveImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
  width: 400px;
  border-radius: 6px;
  background: #233145;
  color: #9198a2;
  border: 1px solid #80808040;
`

type PropsType = {
  data?: AccessibilityImages | null
  newImage: object | null
  onSetNewImage: (image: object) => void
}

const ImageBlock: FC<PropsType> = ({data, newImage, onSetNewImage}) => {
  const {t} = useTranslation()

  return (
    <React.Fragment>
      <Box display={"flex"} justifyContent={'center'}>
        {!data && !newImage ? (
          <NoHaveImage>
            {t('no_picture')}
          </NoHaveImage>
        ) : (
          <img
            src={newImage ? URL.createObjectURL(newImage) : data?.image}
            height={200}
            width={400}
          />
        )}
      </Box>
      <Box mt={3}>
        <input
          accept="image/*"
          type="file"
          id={`editor-picture-input`}
          style={{ display: "none" }}
          onChange={(e) => {
            const {files} = e.target
            if (files && files.length > 0) {
              onSetNewImage(files[0])
            }
          }}
        />
        <label htmlFor={`editor-picture-input`} style={{display: 'flex', justifyContent: 'center'}}>
          <UploadButton>
            <Box mr={1}><CloudUpload/></Box>
            {t('upload_new_picture')}
          </UploadButton>
        </label>
      </Box>
    </React.Fragment>
  )
}

export default ImageBlock